// src/constants/builderConfig.js
// Maps the shed catalog (shedModels.js — the source of truth) into the config
// override the <ShedConfigurator> expects, so the builder prices the shed
// itself (model + size base price) and not just the add-ons.
//
// The customer reaches /configure from a specific model on the storefront, so
// the model + size arrive locked via initialModel/initialDimensions — no model
// picker. basePrices is keyed by model id (slug) then "WxL", in integer cents.

import { SHED_MODELS } from './shedModels';

const toCents = (dollars) => Math.round(Number(dollars) * 100);

export const BUILDER_MODELS = SHED_MODELS.map((m) => ({
  id: m.slug,
  name: m.name,
  description: m.baseDoor ? `Includes ${m.baseDoor}` : undefined,
}));

export const BUILDER_BASE_PRICES = SHED_MODELS.reduce((acc, m) => {
  acc[m.slug] = Object.fromEntries(
    Object.entries(m.prices).map(([size, dollars]) => [size, toCents(dollars)]),
  );
  return acc;
}, {});

// All sizes any model offers — fallback size chips if someone lands on
// /configure with no model context.
const ALL_SIZES = [
  ...new Map(
    SHED_MODELS.flatMap((m) => m.sizes).map((s) => {
      const [w, l] = s.split('x').map(Number);
      return [s, { w, l }];
    }),
  ).values(),
];

/** Deep-merged over the configurator's defaultConfig via the `config` prop. */
export const builderConfig = {
  models: BUILDER_MODELS,
  basePrices: BUILDER_BASE_PRICES,
  sizes: ALL_SIZES,
};
